import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
} from '@chakra-ui/react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { object, string } from 'yup';

const outreachSchema = object().shape({
  title: string()
    .nullable()
    .required('Flow name is required')
    .max(50, 'Flow name cannot exceed 50 characters'),
});

export const OutreachForm = ({
  blueprint = {},
  outreach = {},
  onSubmit = () => {},
  onClose = () => {},
  isLoading = false,
}) => {
  const title = blueprint?.name || outreach?.title;
  const onFormSubmit = async (values, { setErrors }) => {
    try {
      const result = await onSubmit(values);
      if (result?.error?.title?.length) {
        setErrors({ title: result?.error?.title[0] });
        return;
      }
      if (result?.error?.length) {
        setErrors({ title: result?.error[0] });
        return;
      }
    } catch {}
  };

  return (
    <Formik
      validateOnBlur={false}
      initialValues={{
        title: title ? `Copy of ${title}` : '',
      }}
      validationSchema={outreachSchema}
      onSubmit={onFormSubmit}
    >
      <Form
        noValidate
        style={{ display: 'flex', height: '100%', flexDirection: 'column' }}
      >
        <Field name="title">
          {({ field, form }) => (
            <FormControl
              flex="1"
              mb="16px"
              isRequired
              isInvalid={form.errors.title && form.touched.title}
            >
              <FormLabel
                fontWeight="semiBold"
                fontSize="14px"
                htmlFor="title"
                textColor="secondary-900"
              >
                Name the Flow
              </FormLabel>
              <Input
                {...field}
                id="title"
                placeholder="Senior Software Engineer | Seattle"
                data-tracking-id="outreach-create-name"
                data-test-id="outreach-create-name"
                maxLength={50}
              />
              <FormErrorMessage>
                <ErrorMessage name="title" />
              </FormErrorMessage>
            </FormControl>
          )}
        </Field>
        <Flex flexDir="row-reverse" mb="60px">
          <Button
            type="submit"
            data-tracking-id="outreach-create-submit"
            data-test-id="outreach-create-submit"
            isLoading={isLoading}
          >
            Create Flow
          </Button>
        </Flex>
      </Form>
    </Formik>
  );
};
